export default __webpack_public_path__ + "static/media/MM6A_JS6A.863b404a.jpg";